import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './componentes/Header';
import BarraNavegacao from './componentes/BarraNavegacao'; // Importa o componente de barra de navegação para exibir links de navegação em todas as páginas
import Inicio from './paginas/Inicio';
import Cadastro from './paginas/CadastroUsuario';  
import AtivarCadastro from './paginas/AtivarCadastro';
import PoliticaPrivacidade from './paginas/PoliticaPrivacidade/PoliticaPrivacidade';
import Resultado from './paginas/Resultado';
import ResetSenha from './paginas/ResetSenha';
import PainelControle from './paginas/PainelControle';
import ListagemUsuarios from './paginas/ListagemUsuarios';
import PaginaArtigo from './paginas/PaginaArtigo';
import ListagemArtigos from './paginas/ListagemArtigos';
import VerArtigo from "./paginas/VerArtigo";
import ListagemForum from "./paginas/ListagemForum";
import ListagemForumComentarios from "./paginas/ListagemForumComentarios";  
import ListagemForumModeracao from "./paginas/ListagemForumModeracao";
import ListagemForumMinhasMensagens from "./paginas/ListagemForumMinhasMensagens";  // Importa o componente de listagem de mensagens do fórum relacionadas ao usuário logado

function AppRoutes() {
  return (
      <BrowserRouter>
      <Header /> {/* Colocando o Header neste ponto para que fique acessível em todas as páginas */}
      <BarraNavegacao /> {/* Colocando a Barra de Navegação neste ponto para que fique acessível em todas as páginas */}
       <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/cadastro-usuario" element={<Cadastro />} /> {/*Elemento cadastro está me Páginas>CadastroUsuario/index.js*/}
          <Route path="/user-ativar" element={<AtivarCadastro />} />
          <Route path="/reset-senha" element={<ResetSenha />} /> {/*Elemento reset senha está em Páginas>ResetSenha/index.js*/}
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/resultado" element={<Resultado />} /> {/*Elemento resultado está em Páginas>Resultado/index.js*/}
          <Route path="/painel-controle" element={<PainelControle />} /> {/*Elemento painel de controle está em Páginas>PainelControle/index.js*/}
          <Route path="/listagem-usuarios" element={<ListagemUsuarios />} /> {/*Elemento listagem de usuários está em Páginas>ListagemUsuarios/index.js*/}
          <Route path="*" element={<Resultado />} /> {/* Rota para lidar com caminhos não definidos, redirecionando para a página de resultado */}
          <Route path="/cadastro-artigo" element={<PaginaArtigo />} /> {/*Elemento cadastro de artigo está em Páginas>CadastroArtigo/index.js*/}
          <Route path="/listagem-artigos" element={<ListagemArtigos />} /> {/*Elemento listagem de artigos está em Páginas>ListagemArtigos/index.js*/}
          <Route path="/ver-artigo/:uuid" element={<VerArtigo />} /> {/* Rota para visualizar um artigo específico, usando o uuid como parâmetro na URL */}
          <Route path="/listagem-forum" element={<ListagemForum />} /> {/*Elemento forum está em Páginas>ListagemForum/index.js*/}
          <Route path="/listagem-forum-comentarios" element={<ListagemForumComentarios />} /> {/*Elemento forum está em Páginas>ListagemForumComentarios/index.js*/}
          <Route path="/listagem-forum-moderacao" element={<ListagemForumModeracao />}/>{/*Elemento forum está em Páginas>ListagemForumModeracao/index.js*/}
          <Route path="/listagem-forum-minhas-mensagens" element={<ListagemForumMinhasMensagens />} /> {/*Elemento forum está em Páginas>ListagemForumMinhasMensagens/index.js*/}
       </Routes>
      </BrowserRouter>
  );
}

export default AppRoutes;